import { Component, Input, OnInit } from '@angular/core';
import { SettingDefinition } from '../../../models/setting-definition';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectSetting } from '../../../store/profile/profile.state';
import { Observable } from 'rxjs';
import { SettingTypeEnum } from '../../../enum/setting-type.enum';
import { CardEditComponent } from '../card-edit/card-edit.component';
import { profileSubmitSetting } from '../../../store/profile/profile.actions';
import { filter, tap } from 'rxjs/operators';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { AvatarUploadComponent } from '../avatar-upload/avatar-upload.component';
import { MatDialog } from '@angular/material/dialog';
import { ProfileAvatarComponent } from '../../navigation/profile-avatar/profile-avatar.component';
import { MatButton } from '@angular/material/button';
import { ShipmentCardComponent } from '../../shipment/shipment-card/shipment-card.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-setting-control',
    templateUrl: './setting-control.component.html',
    styleUrls: ['./setting-control.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatSelect, MatOption, MatHint, ShipmentCardComponent, MatButton, ProfileAvatarComponent, AsyncPipe]
})
export class SettingControlComponent implements OnInit {

    @Input()
    setting: SettingDefinition;

    readonly CARD = 'CARD';
    readonly INPUT = 'INPUT';
    readonly AVATAR = 'AVATAR';

    typeCategory: string;
    controlType: string;
    display: string = this.INPUT;
    control = new UntypedFormControl('');

    constructor(private store: Store<AppState>, private dialog: MatDialog) {
    }

    value$: Observable<any>;
    value: any;

    ngOnInit(): void {
        this.typeCategory = this.setting.type.split('.')[0];
        this.controlType = this.setting.type;
        this.value$ = this.store.select(selectSetting(this.setting.id)).pipe(
            tap(v => this.value = v),
            tap(v => this.control.setValue(v))
        );
        this.display = 'INPUT';

        if (this.controlType === SettingTypeEnum.CARD) {
            this.display = 'CARD';
        }
        if (this.controlType === SettingTypeEnum.AVATAR) {
            this.display = 'AVATAR';
        }
    }

    valueChanged(): void {
        this.store.dispatch(profileSubmitSetting({ id: this.setting.id, value: this.control.value }));
    }

    editCard(): void {
        this.dialog.open(CardEditComponent, { data: { card: this.value }})
            .afterClosed()
            .pipe(filter(c => !!c))
            .subscribe(value => this.store.dispatch(profileSubmitSetting({ id: this.setting.id, value })));
    }

    uploadAvatar(): void {
        this.dialog.open(AvatarUploadComponent, { width: '400px', height: '300px', data: { url: this.value } })
            .afterClosed()
            .pipe(
                filter(c => !!c)
            )
            .subscribe(value => this.store.dispatch(profileSubmitSetting({ id: this.setting.id, value })));
    }
}
